<div class="content">
  <div class="first-part flex">
    <div class="title">爆米花流媒体播放器</div>
    <div class="tip">一个会员即可在电脑端纵览原版</div>
    <div class="tip">
      Netfix、Disney+、Max、Prime Video、Crunchyroll五大平台
    </div>

    <!-- <div class="downloads">
      <div class="download active" [matMenuTriggerFor]="menu">
        Windows
        <mat-icon style="margin-left: 10px"> keyboard_arrow_down </mat-icon>
      </div>
      <div class="download active" (click)="downloadmacOS()">MacOS</div>
      <div class="download">TV OS<br />开发中</div>
      <div class="download">Android/ios<br />开发中</div>
    </div> -->
    <div class="imgs">
      <img
        *ngFor="let item of [1, 2, 3, 4, 5]"
        src="../../../assets/images/popcorn/seond-part-{{ item }}.webp"
        width="135"
        height="134"
        alt=""
      />
    </div>
  </div>
  <div class="second-title">价格对比</div>
  <div class="second-part">
    <div class="left">
      <div class="txt">产品</div>
      <div class="divider"></div>
      <div class="txt">Netfix</div>
      <div class="divider"></div>
      <div class="txt">Disney+</div>
      <div class="divider"></div>
      <div class="txt">Max</div>
      <div class="divider"></div>
      <div class="txt">Prime Video</div>
      <div class="divider"></div>
      <div class="txt">Crunchyroll</div>
      <div class="divider"></div>
      <div class="txt">全家桶</div>
    </div>
    <div class="middle">
      <img src="../../../../assets/images/popcorn/logo.png" alt="" />
      <div class="txt">爆米花</div>
      <div class="divider"></div>
      <div class="txt">¥16.88/月</div>
      <div class="divider"></div>
      <div class="txt">¥15.88/月</div>
      <div class="divider"></div>
      <div class="txt">¥8.88/月</div>
      <div class="divider"></div>
      <div class="txt">¥8.88/月</div>
      <div class="divider"></div>
      <div class="txt">¥9.88/月</div>
      <div class="divider"></div>
      <div class="txt">
        爆米花全家桶
        <span style="text-decoration-line: line-through">= ¥60.40/月</span>
        <br />
        全家桶7折
        <span style="text-decoration-line: line-through">= ¥39.88/月</span>
        <br />
        新用户首单半价<br />
        <span style="color: #ff4545">=¥19.94/月</span>
      </div>
    </div>
    <div class="right">
      <div class="txt">官方售价</div>
      <div class="divider"></div>
      <div class="txt">≈ ¥140/月</div>
      <div class="divider"></div>
      <div class="txt">≈ ¥115/月</div>
      <div class="divider"></div>
      <div class="txt">≈ ¥110/月</div>
      <div class="divider"></div>
      <div class="txt">≈ ¥55/月</div>
      <div class="divider"></div>
      <div class="txt">≈ ¥60/月</div>
      <div class="divider"></div>
      <div class="txt" style="color: #ff4545">≈ ¥475/月</div>
    </div>
  </div>
  <div class="third-part">
    <div class="product">
      <img src="../../../../assets/images/popcorn/windows.png" alt="" />
      <div class="name">Windows</div>
      <div class="download active" [matMenuTriggerFor]="menu">
        下载
        <mat-icon style="margin-left: 10px"> keyboard_arrow_down </mat-icon>
      </div>
    </div>
    <div class="product">
      <img src="../../../../assets/images/popcorn/macos.png" alt="" />
      <div class="name">macOS</div>
      <!-- <div class="download active" (click)="downloadmacOS()">下载</div> -->
      <div class="download active" [matMenuTriggerFor]="menu1">
        下载
        <mat-icon style="margin-left: 10px"> keyboard_arrow_down </mat-icon>
      </div>
    </div>
  </div>
</div>
<mat-menu #menu="matMenu" class="menuPopcorn">
  <button mat-menu-item (click)="downloadWindows(1)">谷歌浏览器版</button>
  <mat-divider></mat-divider>
  <button mat-menu-item (click)="downloadWindows(2)">
    Edge浏览器4K版（推荐）
  </button>
  <mat-divider></mat-divider>
  <button mat-menu-item (click)="downloadWindows(3)">
    Edge浏览器4K版（仅海外使用）
  </button>
</mat-menu>

<mat-menu #menu1="matMenu" class="menuPopcorn">
  <button mat-menu-item (click)="downloadmacOS(1)">国内使用版</button>
  <mat-divider></mat-divider>
  <button mat-menu-item (click)="downloadmacOS(2)">海外使用版</button>
</mat-menu>
